module.exports = __webpack_public_path__ + "img/1613044739.673e38ec.png";